export default __webpack_public_path__ + "static/media/learose4-1920w.c311c3f0.webp";